export class CustomValidators {
  static checkPasswords(formControl: any) {
    let password: any = formControl.get('password').value;
    let passwordConfirm: any = formControl.get('password_confirm').value;
    return password === passwordConfirm
      ? null
      : formControl
          .get('password_confirm')
          .setErrors({ notMatchPassword: true });
  }

  static facilityKanaName(formControl: any) {
    const kana: any = formControl.get('facilityKanaName').value;
    return !!kana.match(/^[ァ-ヶー　]*$/)
      ? null
      : formControl.get('facilityKanaName').setErrors({ notMatchKana: true });
  }

  static kana(formControl: any) {
    const kana: any = formControl.get('kana').value;
    return !!kana.match(/^[ァ-ヶー　]*$/)
      ? null
      : formControl.get('kana').setErrors({ notMatchKana: true });
  }
}
